/* global window */
import React from 'react';
import {
  CheckOutlined,
  StockOutlined,
  TeamOutlined,
  DashboardFilled,
  SettingOutlined,
  ToolFilled,
  PoweroffOutlined,
  InfoCircleOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  HomeOutlined,
  CarOutlined,
  UploadOutlined,
  RocketFilled,
  ShopFilled,
  TagsFilled,
  ReadFilled,
  LayoutFilled,
  SignalFilled,
  LikeFilled,
  HomeFilled,
  NotificationFilled,
  CalendarFilled,
  RobotFilled,
  CheckSquareFilled
} from '@ant-design/icons';
import { GiIceSkate } from 'react-icons/gi';
import { HiUserGroup } from 'react-icons/hi';
import { Layout, Menu, Row, Col, Space, Button, Popover } from 'antd';
import LogoSmall from '../../static/logo-small.png';
import logo from 'src/static/logo-white.svg';
import logoOpen from "src/static/logo-open.svg";
import logoPowered from "src/static/logo-powered.svg";
import logoClosed from "src/static/logo-close.svg";
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Cookies } from 'react-cookie';
import { getSidebarCollapsed, getUser } from 'src/redux/selectors';
import { findAllSites } from 'src/redux/actions/sites';
import {
  SITE_SIDEBAR_TABS,
  resolveSiteSidebarTabs
} from 'src/constants/sidebarTabs';
import { collapseSidebar } from 'src/redux/actions/status';
import { useIsMobile } from 'src/utils/responsive';
import { MenuItem } from 'rc-menu';
import { BiRocket } from 'react-icons/bi';

const StyledLink = styled(Link)`
  font-size: 15px;
  color: white !important;
  :hover {
    text-decoration: none !important;
  }
  .anticon svg {
    display: inline-block;
    font-size: 20px !important;
    color: black !important;
  }
`;

const { Sider } = Layout;

// Icon per tab, kept out of the shared constants file so that stays free of
// component imports.
const TAB_ICONS = {
  dashboard: LayoutFilled,
  sitemanagement: HomeFilled,
  users: RobotFilled,
  stock: SignalFilled,
  specialmanagement: NotificationFilled,
  tailoringmanagement: CalendarFilled,
  experiencemanagement: LikeFilled,
  checklists: CheckSquareFilled
};

// These two were already hidden on phones before the tabs became configurable;
// keeping that so the config controls *which* tabs exist, not the mobile trim.
const HIDE_ON_MOBILE = ['sitemanagement', 'users'];

const Sidebar = props => {
  const isMobile = useIsMobile();
  const { user, sites, findAllSites } = props;

  // Sites are normally fetched by whichever page mounts, but on a fresh login
  // the sidebar can render first. Pull them in so the menu doesn't sit on the
  // fallback set longer than necessary.
  React.useEffect(() => {
    if (!sites || !sites.length) {
      Promise.resolve(findAllSites()).catch(() => {
        // Non-fatal: resolveSiteSidebarTabs falls back to the full set.
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const allowedTabs = resolveSiteSidebarTabs(user, sites);
  const visibleTabs = SITE_SIDEBAR_TABS.filter(
    tab =>
      allowedTabs.includes(tab.key) &&
      !(isMobile && HIDE_ON_MOBILE.includes(tab.key))
  );

  const signOut = () => {
    // if (window.cordova) {
    //   window.FirebasePlugin.getToken(
    //     token => {
    //       window.pubnub.push.deleteDevice(
    //         {
    //           device: token,
    //           pushGateway: 'gcm' // apns, gcm, mpns
    //         },
    //         function (status) {
    //           if (status.error) {
    //             console.log('operation failed w/ error:', status);
    //           }
    //         }
    //       );
    //     },
    //     error => {
    //       console.error(error);
    //     }
    //   );
    // }

    // const cookies = new Cookies();
    // cookies.remove('token');
    // cookies.remove('basic');
    // localStorage.clear();
    // window.location.reload();
  };

  return (
    <Sider
      // collapsed={true}
      collapsed={props.collapsed}
      width={300}
      // On mobile the sidebar leaves the flow entirely when collapsed and
      // overlays the page when open, so the content gets the full width.
      collapsedWidth={isMobile ? 0 : 80}
      trigger={isMobile ? null : '>'}
      onCollapse={props.collapseSidebar}
      collapsible
      style={{
        position: "fixed",
        backgroundColor: "black",
        border: "none",
        borderRadius: "1em 1em 0em 0em",
        minHeight: "100vh",
        boxShadow: "4px 4px 4px rgba(0, 0, 0, 0.02)",
        zIndex: isMobile ? 99 : undefined,
        // borderRight: "1px solid rgba(0, 0, 0, 0.07)"
      }}
    >
      <div style={{ margin: "auto", textAlign: "center" }}>
        <img
          // onClick={props.collapseSidebar}
          style={{ margin: "auto", width: !props.collapsed ? "20em" : "4em", marginBottom: !props.collapsed ? "0.7em" : "0em", marginTop: !props.collapsed ? "2em" : "2em", padding: !props.collapsed ? "0.5em" : "0.5em", paddingTop: 0, paddingBottom: 0 }}
          alt="Profile"
          src={props.collapsed ? logoClosed : logoOpen}
        />
      </div>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={['dashboard']}
        onClick={() => {
          if (isMobile && !props.collapsed) {
            props.collapseSidebar();
          }
        }}
        style={{ background: 'transparent', marginTop: '3vh' }}
      >
        {visibleTabs.map(tab => {
          const Icon = TAB_ICONS[tab.key] || NotificationFilled;
          return (
            <Menu.Item
              key={tab.key}
              onClick={
                isMobile
                  ? undefined
                  : props.collapsed
                    ? null
                    : props.collapseSidebar
              }
              icon={
                <Icon
                  style={{
                    fontSize: '20px',
                    color: 'white',
                    marginTop: props.collapsed ? '0.5em' : 0
                  }}
                />
              }
            >
              <StyledLink to={tab.path}>
                <span>{tab.label}</span>
              </StyledLink>
            </Menu.Item>
          );
        })}

        {/* <Menu.Item
          onClick={props.collapsed ? null : props.collapseSidebar}
          key="pexunits"
          icon={<HomeOutlined style={{ fontSize: '20px', color: 'black' }} />}
        >
          <StyledLink to="/admin/pexunit">
            <span>Home View Management</span>
          </StyledLink>
        </Menu.Item> */}
        {/* <Menu.Item

          key="settings"

        >
          <StyledLink to="/admin/account">
            <SettingOutlined
              type="check"
              style={{
                fontSize: '20px',
                paddingRight: '12px',
                color: 'red'
              }}
            />
            <span>Settings</span>
          </StyledLink>
        </Menu.Item> */}
        {/* <Menu.Item onClick={props.collapseSidebar} key="pexrequests">
          <StyledLink to="/admin/pexrequests">
            <SettingOutlined
              type="check"
              style={{
                fontSize: '20px',
                paddingRight: '12px',
                color: '#f15b2b'
              }}
            />
            <span style={{ fontSize: '15px' }}>PEX Requests</span>
          </StyledLink>
        </Menu.Item> */}
        {/* <Menu.Item onClick={props.collapseSidebar} key="requests">
          <StyledLink to="/admin/requests">
            <CheckOutlined
              type="check"
              style={{
                fontSize: '20px',
                paddingRight: '12px',
                color: '#f15b2b'
              }}
            />
            <span style={{ fontSize: '15px' }}>Requests</span>
          </StyledLink>
        </Menu.Item> */}
      </Menu>
      {!isMobile ? 
      <div style={{ margin: "auto", textAlign: "center" }}>
        <img
          // onClick={props.collapseSidebar}
          style={{
            margin: "auto",
            position: "absolute",
            left: 0,
            right: 0,
            bottom: "8em",
            width: !props.collapsed ? "10em" : "6em",
            marginBottom: !props.collapsed ? "0.7em" : "0em",
            marginTop: !props.collapsed ? "2em" : "2em",
            padding: !props.collapsed ? "0.5em" : "0.5em", paddingTop: 0, paddingBottom: 0
          }}
          alt="Profile"
          src={logoPowered}
        />
      </div> : null}
    </Sider>
  );
};

const mapStateToProps = state => {
  return {
    collapsed: getSidebarCollapsed(state),
    user: getUser(state) || {},
    sites: state.sites.allSites || []
  };
};

const mapDispatchToProps = {
  collapseSidebar,
  findAllSites
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Sidebar)
);
